import * as React from 'react';
import clsx from 'clsx';
import leftArrowSvg from '@/assets/images/svg/left_arrow.svg';
import type { SidebarToggleProps } from './types';

/**
 * SidebarToggle Component
 * Renders the floating circular button to expand/collapse the sidebar.
 * Uses project SVG assets from /assets/images/svg.
 */
export const SidebarToggle: React.FC<SidebarToggleProps> = ({ isCollapsed, onToggle }) => (
  <button
    type='button'
    onClick={onToggle}
    className={clsx(
      'absolute right-[-18px] top-[30px] z-50',
      'flex size-[36px] items-center justify-center',
      'border-none bg-transparent outline-none',
      'cursor-pointer transition-transform hover:opacity-80',
      isCollapsed ? 'rotate-180' : 'rotate-0'
    )}
    aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
  >
    <img src={leftArrowSvg} alt='' className='size-full' />
  </button>
);

export default SidebarToggle;
